<template>
  <div class="power-up">
    <div class="power-icon">
      <img src="/images/power-ups/grab-your-fans.png" class="power-icon-img" />
    </div>
    <div class="power-title">Grab Your Fans</div>
    <div
      class="power-description"
    >Readers who have given one of your books 5-stars before will see your other books highlighted at the top of their library page when you're looking for readers.</div>
    <div
      class="power-toggle"
      :class="{'power-toggle-on':toggle, 'power-toggle-off':!toggle}"
      @click="clickToggle"
    >
      <div class="power-toggle-dial"></div>
    </div>

    <div class="power-cost" v-if="!toggle">
      <points :count="600"></points>
      <div class="power-cost-more">
        Costs 600 snaps to enable
        <br />
        <span style="color: #777; font-weight: 500">Never expires and works with all of your books</span>
      </div>
    </div>
  </div>
</template>

<script>
import PowerUp from "./PowerUp";
import Points from "@/components/Points/Tag";
import Back from "../../modules/Back";
import Bus from "../../modules/Bus";

export default {
  name: "PowerUps",
  props: ["user"],
  components: {
    PowerUp,
    Points
  },
  data: function() {
    return {
      toggle: false
    };
  },
  methods: {
    async clickToggle() {
      if (this.toggle) {
        return;
      }

      if (this.user.points < 600) {
        this.$toasted.show("You need 600 snaps to turn on Grab Your Fans.", {
          icon: "error",
          position: "bottom-center",
          duration: 2000
        });
        return;
      }

      const response = await Back.enableGrabYourFans();

      if (response) {
        this.$toasted.show(
          "Great! You have turned on the Grab Your Fans Power Up! You now have it forever.",
          {
            icon: "check_circle",
            position: "bottom-center",
            duration: 4000
          }
        );
        Bus.$emit("UserChanged");
      } else {
        this.$toasted.show(
          "Oops! Something went wrong. Please try again later.",
          {
            icon: "error",
            position: "bottom-center",
            duration: 3000
          }
        );
        return;
      }

      this.toggle = true;
    }
  },
  mounted() {
    if (this.user.is_grab_your_fans) {
      this.toggle = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.power-up {
  float: left;
  width: 440px;
  min-height: 94px;
  background: #fff;
  box-shadow: 0px 1px 0.5rem rgba(116, 75, 75, 0.25);
  margin: 24px 0px 6px 70px;
  padding: 12px 0 24px 0 !important;
  border-radius: 8px;
  font-family: "Source Sans Pro";
}

.power-icon {
  text-align: center;
  padding-top: 4px;
}
.power-icon-img {
  width: 66px;
}

.power-title {
  margin-top: -4px;
  padding: 0 0 12px 0;
  text-align: center;
  color: $color-snaps;
  font-family: "Source Sans Pro";
  font-weight: 600;
  font-size: 15pt;
}

.power-toggle {
  margin: 0 auto;
  width: 80px;
  height: 34px;
  background: #eee;
  border-radius: 40px;
  transition: 0.15s background ease-out;
}
.power-toggle-dial {
  float: left;
  width: 24px;
  height: 24px;
  margin: 5px 6px;
  background: #fff;
  border-radius: 30px;
  box-shadow: 0px 1px 0.3rem rgba(116, 75, 75, 0.45);
}
.power-toggle-on {
  background: lighten(#efb86a, 10%);
  .power-toggle-dial {
    float: right;
    box-shadow: 0 !important;
  }
}
.power-toggle-off:hover {
  cursor: pointer;
  background: #e3e3e3;
}

.power-description {
  padding: 0px 38px 20px 38px;
  text-align: center;
  color: #222;
  font-family: "Source Sans Pro";
  font-weight: 500;
  font-size: 12pt;
  line-height: 1.4em;
}

.power-cost {
  padding-top: 8px;
  padding-bottom: 12px;
  color: $color-snaps;
}

.power-cost-more {
  color: darken($color-snaps, 6%);
  padding: 10px 38px 0px 38px;
  text-align: center;
  font-family: "Source Sans Pro";
  font-weight: 600;
  font-size: 11.5pt;
  line-height: 1.5em;
}

@media (max-width: 768px) {
  .power-up {
    float: none;
    width: 90%;
    min-height: 94px;
    background: #fff;
    box-shadow: 0px 1px 0.5rem rgba(116, 75, 75, 0.25);
    margin: 24px auto 6px auto;
    padding: 12px 0 24px 0 !important;
    border-radius: 8px;
    font-family: "Source Sans Pro";
  }
}
</style>